var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPregnantWoman2Icon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 255,
    height: 233,
    viewBox: "0 0 255 233",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M55.5146 111.521C55.5146 111.521 62.6452 105.558 69.3867 109.123C69.3867 109.123 77.2949 113.596 74.8965 122.217L63.8768 148.276",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M154.303 214.394C151.904 190.345 148.728 153.591 121.244 136.413C127.466 120.078 114.761 107.892 104.584 107.892H65.1725L36.0673 199.809C36.0673 199.809 34.3171 213.811 32.0483 232.285H155.988C155.275 225.22 154.692 219.061 154.238 214.459L154.303 214.394Z",
    fill: "#A3C5EB"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M155.988 231.572C155.34 224.766 154.757 218.802 154.303 214.329C151.905 190.28 148.728 153.526 121.244 136.348C127.467 120.013 114.762 107.827 104.585 107.827H65.1727L36.0675 199.744C36.0675 199.744 34.3822 213.422 32.1782 231.572H155.988Z",
    stroke: "#6F7C87",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M61.089 108.28C55.3846 101.928 54.3474 88.0558 64.5893 82.8052C57.5885 68.4147 68.4787 58.6266 79.1095 63.3586C79.1095 52.7926 92.4628 49.4219 97.9727 58.9507C98.5561 59.9879 99.334 61.3491 100.047 62.7104L76.3222 76.1934C74.8312 77.0361 74.3127 78.8511 75.0906 80.4068C76.5815 83.259 78.7206 87.4076 79.2391 88.5744C80.017 90.3246 80.4707 92.7878 80.4707 95.0566V107.827C73.794 107.827 66.923 107.827 65.6265 107.891C62.8392 107.891 61.2186 108.28 61.2186 108.28H61.089Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M81.1201 85.9817C79.5643 81.7683 83.8427 76.8418 88.3803 82.0924L104.586 73.147C104.651 73.9248 104.715 74.7027 104.586 75.675C103.938 83.9074 103.16 92.6584 103.16 92.6584C102.576 97.196 98.8165 100.632 94.279 100.826V107.762C94.279 107.762 87.4079 107.762 80.4071 107.762V94.992C80.4071 92.6584 79.9533 90.26 79.1754 88.5098C79.0458 88.3153 78.9161 87.9912 78.7217 87.6023L81.2498 86.1762V85.9817C81.185 85.9817 81.1849 85.9817 81.1849 85.9817H81.1201Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M125.265 139.136L132.979 126.561L136.739 129.672L154.37 93.1772C155.537 90.7139 158.065 89.1582 160.788 89.1582H176.086C178.614 89.1582 180.688 91.2325 180.688 93.7606C180.688 96.2886 179.262 97.6499 177.252 98.2333L166.622 101.085L152.75 147.952C151.064 153.721 145.165 156.962 139.656 155.795L137.84 152.943C135.701 149.508 131.812 145.359 130.905 144.387C129.673 143.155 127.728 141.21 125.2 139.33L125.265 139.136Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M115.929 112.559L132.977 126.56L125.264 139.136C124.032 138.163 122.671 137.256 121.18 136.348C124.81 127.921 122.217 118.133 115.929 112.559Z",
    stroke: "#6F7C87",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M72.5636 107.827H73.7954C78.5922 107.827 82.4166 111.716 82.4166 116.448V204.087C63.0996 207.004 48.2554 202.791 40.6712 200.522C33.0222 198.253 31.3369 200.976 31.3369 200.976C31.3369 200.976 31.9203 190.928 35.68 183.798L49.8112 159.749L66.4055 107.762H72.5636V107.827Z",
    fill: "white"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M28.7424 167.074L42.3551 138.552L63.4869 149.313L58.9494 159.814L83.7763 157.156L94.2774 147.627C95.7683 146.396 98.0371 146.396 99.4632 147.692C100.889 148.924 101.213 151.063 100.241 152.683L95.3794 162.342C92.9809 166.491 89.0918 169.602 84.4894 170.963L41.1233 183.668C34.5763 185.678 27.77 181.335 26.9921 174.528C26.668 171.806 27.3163 169.213 28.7424 167.139V167.074Z",
    fill: "white"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M42.3579 138.553L54.0259 114.244C56.165 109.836 60.8322 107.308 65.6938 107.957C73.1484 108.929 77.6211 116.837 74.5744 123.708L63.4898 149.378L42.3579 138.617V138.553Z",
    fill: "white"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M31.3365 201.041C30.2346 203.245 32.1144 205.902 35.2259 206.551L36.0684 199.744C36.0684 199.744 32.1792 199.291 31.3365 201.041Z",
    fill: "white"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M84.4902 92.5285C85.0087 97.2605 89.0276 100.826 93.8245 100.826C98.6213 100.826 102.511 97.3253 103.159 92.6581C103.159 92.6581 103.937 83.9071 104.585 75.6747C104.715 73.7301 104.52 72.4336 104.131 71.0724C103.742 69.7111 100.177 62.7752 97.9083 58.8858C92.4632 49.357 79.045 52.7926 79.045 63.2937C68.4142 58.5617 57.5242 68.285 64.5249 82.7404C54.2831 87.9261 55.3201 101.798 61.0244 108.215",
    stroke: "#6F7C87",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M94.2783 100.956V107.762",
    stroke: "#6F7C87",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M83.9076 89.0934C77.1661 85.2689 82.5465 75.3511 88.3804 82.0278",
    stroke: "#6F7C87",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M78.6567 87.6025C80.1476 90.4547 78.5919 87.4081 79.1105 88.51C79.8883 90.2602 80.342 92.7235 80.342 94.9922V107.827",
    stroke: "#6F7C87",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M81.1849 86.1763L78.7217 87.6024",
    stroke: "#6F7C87",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M136.736 129.672L114.891 111.716",
    stroke: "#6F7C87",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M83.7769 157.156L94.2781 147.627C95.8338 146.396 98.0378 146.396 99.4638 147.757C100.89 148.989 101.214 151.128 100.242 152.748L95.38 162.407C92.9816 166.555 89.0924 169.667 84.49 171.028L41.124 183.733C34.577 185.743 27.7706 181.4 26.9928 174.593C26.2797 168.63 30.4283 163.185 36.392 162.407L83.7769 157.286V157.156Z",
    stroke: "#6F7C87",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M28.7439 167.074L36.9114 150.091M58.9508 159.814L74.573 123.708C77.6197 116.772 73.147 108.929 65.6924 107.956C60.8308 107.308 56.1636 109.901 54.0245 114.244L48.1905 126.43H1",
    stroke: "#6F7C87",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M63.4898 149.313L42.3579 138.552",
    stroke: "#6F7C87",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M82.4812 171.482V204.152C63.1642 207.069 48.32 202.856 40.7358 200.587C33.0868 198.318 31.4014 201.041 31.4014 201.041C31.4014 201.041 31.9848 190.993 35.6797 183.863",
    stroke: "#6F7C87",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M72.5625 107.827H73.7942C78.591 107.827 82.4154 111.716 82.4154 116.448V157.221",
    stroke: "#6F7C87",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M31.3381 201.041C30.3658 203.31 32.116 205.903 35.2274 206.551",
    stroke: "#6F7C87",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M150.479 72.6283H154.692C156.378 72.6283 157.609 70.9429 157.091 69.3223L142.7 24.0117H133.171L148.016 70.8132C148.34 71.8504 149.312 72.5634 150.414 72.5634L150.479 72.6283Z",
    fill: "white"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M185.029 3.59288L184.186 1H135.44L157.155 69.3873C157.674 71.0078 156.442 72.6932 154.757 72.6932H150.544C149.442 72.6932 148.469 71.9801 148.145 70.943L133.301 24.1415",
    stroke: "#6F7C87",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M142.766 64.5905L144.97 71.5913C146.007 74.7675 148.924 76.9067 152.294 76.9067H197.864C203.05 76.9067 206.745 71.8505 205.189 66.9241L193.197 29.1328C192.29 26.2158 194.429 23.2988 197.475 23.2988H254",
    stroke: "#6F7C87",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M142.768 24.0767H129.868L137.193 47.2181",
    stroke: "#6F7C87",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M138.748 1L160.399 69.1928C161.63 73.0173 158.713 76.9714 154.694 76.9714",
    stroke: "#6F7C87",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M186.586 8.58407L185.03 3.59277",
    stroke: "#6F7C87",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M137.255 47.2178C138.163 50.0699 136.024 52.9221 133.042 52.9221H127.143C124.68 52.9221 122.735 54.8668 122.735 57.33",
    stroke: "#6F7C87",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M158.971 21.1595C160.397 19.5389 160.073 16.8164 158.128 15.0014C156.248 13.2512 153.461 13.1216 152.035 14.7421C150.609 16.3627 150.933 19.0852 152.877 20.9002C154.822 22.6504 157.545 22.78 158.971 21.1595Z",
    stroke: "#F39200",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M150.998 18.113C150.48 15.7146 152.36 13.7699 155.147 13.7051L154.239 13.4458C151.322 13.4458 149.896 15.6497 150.415 18.0482C150.933 20.4466 153.073 22.4561 155.925 22.4561L156.573 22.1968C153.656 22.1968 151.582 20.4466 151.063 18.0482H150.998V18.113Z",
    stroke: "#F39200",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M159.037 21.1595C160.463 19.5389 160.139 16.8164 158.194 15.0014C156.315 13.2512 153.527 13.1216 152.101 14.7421C150.61 16.3627 150.999 19.0852 152.944 20.9002C154.824 22.6504 157.611 22.78 159.037 21.1595Z",
    stroke: "#F39200",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M154.175 13.5752H153.786C151.388 13.5752 149.832 15.5199 150.286 17.9183C150.74 20.3167 153.009 22.2614 155.342 22.2614H155.796",
    stroke: "#F39200",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M153.981 18.1779L156.12 19.6688L156.314 15.3257",
    stroke: "#F39200",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M165.064 15.7144H180.751",
    stroke: "#6F7C87",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M165.714 19.0205H182.697",
    stroke: "#6F7C87",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M165.518 40.7361C166.944 39.1156 166.62 36.3931 164.675 34.5781C162.731 32.8279 160.008 32.6982 158.582 34.3188C157.156 35.9393 157.48 38.6618 159.425 40.4769C161.369 42.2271 164.092 42.3567 165.518 40.7361Z",
    stroke: "#F39200",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M157.546 37.7541C157.027 35.3557 158.907 33.411 161.759 33.3462L160.852 33.0869C157.935 33.0869 156.509 35.2909 157.027 37.6893C157.546 40.0877 159.685 42.0972 162.537 42.0972L163.185 41.8379C160.268 41.8379 158.194 40.0877 157.675 37.6893H157.611L157.546 37.7541Z",
    stroke: "#F39200",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M165.52 40.7361C166.946 39.1156 166.621 36.3931 164.677 34.5781C162.732 32.8279 160.01 32.6982 158.583 34.3188C157.093 35.9393 157.481 38.6618 159.426 40.4769C161.306 42.2271 164.093 42.3567 165.52 40.7361Z",
    stroke: "#F39200",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M160.721 33.2163H160.332C157.998 33.2163 156.377 35.161 156.831 37.5594C157.285 39.9578 159.554 41.9025 161.887 41.9025H162.341",
    stroke: "#F39200",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M160.525 37.754L162.665 39.2449L162.924 34.9019",
    stroke: "#F39200",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M170.964 33.9941H186.651",
    stroke: "#6F7C87",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M171.611 37.3003H188.595",
    stroke: "#6F7C87",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M172.258 40.5415H183.991",
    stroke: "#6F7C87",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M172.064 61.0252C173.49 59.4047 173.166 56.6821 171.221 54.8671C169.341 53.1169 166.554 52.9873 165.128 54.6078C163.637 56.2284 164.026 58.9509 165.971 60.7659C167.915 62.5809 170.638 62.6458 172.064 61.0252Z",
    stroke: "#F39200",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M164.093 57.9787C163.574 55.5803 165.454 53.6356 168.306 53.5708L167.399 53.3115C164.482 53.3115 163.056 55.5155 163.575 57.9139C164.093 60.3123 166.232 62.3218 169.084 62.3218L169.733 62.0625C166.88 62.0625 164.741 60.3123 164.223 57.9139H164.158L164.093 57.9787Z",
    stroke: "#F39200",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M172.065 61.0252C173.556 59.4047 173.167 56.6822 171.223 54.8671C169.278 53.0521 166.556 52.9873 165.129 54.6079C163.703 56.2284 164.028 58.9509 165.972 60.7659C167.917 62.581 170.639 62.6458 172.065 61.0252Z",
    stroke: "#F39200",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M167.27 53.4409H166.881C164.483 53.4409 162.927 55.3856 163.381 57.784C163.835 60.1824 166.103 62.1271 168.437 62.1271H168.891",
    stroke: "#F39200",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M167.008 58.0436L169.147 59.5345L169.407 55.1914",
    stroke: "#F39200",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M177.512 55.5801H194.495",
    stroke: "#6F7C87",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M178.159 58.8213H189.891",
    stroke: "#6F7C87",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M88.7047 83.2594C88.5102 82.4167 88.4453 81.574 88.4453 80.6665C88.4453 74.0547 93.5662 68.7393 99.9188 68.7393C106.271 68.7393 101.928 68.7393 103.16 69.2578",
    stroke: "#6F7C87",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M132.976 126.56L125.262 139.136",
    stroke: "#6F7C87",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M130.839 144.062C130.904 142.636 131.228 141.21 131.876 139.849L140.951 121.05",
    stroke: "#6F7C87",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M122.671 57.3301V91.5561C122.671 94.0194 124.68 96.0288 127.144 96.0288H149.961C151.711 96.0288 153.267 95.0565 153.98 93.5008L154.11 93.3063C155.276 90.8431 157.804 89.2873 160.527 89.2873H175.825C178.353 89.2873 180.427 91.3617 180.427 93.8897C180.427 96.4178 179.001 97.779 176.992 98.3624L166.361 101.215L152.489 148.081C150.804 153.72 145.229 156.962 139.784 155.989",
    stroke: "#6F7C87",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPregnantWoman2Icon);
export default __webpack_public_path__ + "static/media/pregnant-woman-2-icon.c1bea5f9.svg";
export { ForwardRef as ReactComponent };